import { livePageTestIDs } from '@constants';
import { navigationService } from '@services';

export const onBackPress = () => {
  const currentRoute = navigationService.getCurrentRoute();
  const { backButtonDestination } = navigationService.getCurrentRouteParameters() ?? {};

  // If the back button is pressed while the live page is focused, and the
  // back button destination has been overriden, then handle that now.
  if (currentRoute === livePageTestIDs.livePage && backButtonDestination != null) {
    navigationService.navigate(backButtonDestination);
    return true;
  }

  // Use the default back button action.
  return false;
};
